import Slideshow from "@/js/libs/slideshow";
import qsa from "1dr-utils/helpers/elsForEach";

document.addEventListener("DOMContentLoaded", () => {
  let w = window.innerWidth;

  const isVisible = function (elem) {
    return !!(
      elem.offsetWidth ||
      elem.offsetHeight ||
      elem.getClientRects().length
    );
  };

  qsa(".ss", (container) => {
    let slideshow = new Slideshow({
      container: container,
      slide: ".ss__slide",
      distance: 0,
      minPan: 0,
      z: 1,
      fadeInDelay: 0,
      duration: 7000,
      playNextAt: 3000,
      fadeOutDelay: 500,
      fadeDuration: 1200,
    });

    if (slideshow.ready) {
      if (isVisible(container)) {
        slideshow.start();
      }
    }

    // Either way, listen for a start and a stop
    window.addEventListener("resize.end", function () {
      let newW = window.innerWidth;

      if (newW != w) {
        let containerVisible = isVisible(container);
        if (!slideshow.animating && containerVisible) {
          slideshow.start();
        } else if (!containerVisible) {
          slideshow.stop();
        }
      }

      w = newW;
    });
  });
});
